import { UiHeaderNavModel } from "../../models";

export function mockUiHeaderNavModel({
    id = "header-1234",
    type = "uiHeaderNav",
    locale = "en",
    content = mockUiHeaderNavModelContent()
}: Partial<UiHeaderNavModel> = {}): UiHeaderNavModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiHeaderNavModelContent = UiHeaderNavModel["content"];

export function mockUiHeaderNavModelContent({
    entryTitle = "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    goBackText = "Back",
    ...optionals
}: Partial<UiHeaderNavModelContent> = {}): UiHeaderNavModelContent {
    return {
        entryTitle,
        goBackText,
        ...optionals
    };
}
